import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Google Analytics Component
 * Tracks page views and events
 * 
 * Setup:
 * 1. Get your GA tracking ID from https://analytics.google.com
 * 2. Replace 'G-XXXXXXXXXX' with your actual tracking ID
 * 3. Add this component to your App.jsx
 */

const GoogleAnalytics = () => {
  const location = useLocation();
  const GA_TRACKING_ID = 'G-XXXXXXXXXX'; // Replace with your tracking ID

  useEffect(() => {
    // Load Google Analytics script
    if (typeof window.gtag === 'undefined') {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
      script.async = true;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', GA_TRACKING_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', GA_TRACKING_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

// Helper functions for tracking custom events
export const trackEvent = (category, action, label = null, value = null) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Predefined event trackers
export const trackLogin = (method) => {
  trackEvent('User', 'login', method);
};

export const trackSignup = (role) => {
  trackEvent('User', 'signup', role);
};

export const trackSymptomSubmit = () => {
  trackEvent('Symptom', 'submit');
};

export const trackDoctorResponse = (responseType) => {
  trackEvent('Doctor', 'response', responseType);
};

export const trackChatMessage = () => {
  trackEvent('Chat', 'message_sent');
};

export const trackNotificationClick = (notificationType) => {
  trackEvent('Notification', 'click', notificationType);
};

export default GoogleAnalytics;
